<script setup lang="ts">
import type { FunctionalComponent, Component } from 'vue';
import {
    RiLink,
    RiMailLine,
    RiPencilLine,
    RiPhoneLine,
    RiSchoolLine,
    RiCalendar2Line,
    RiLockLine,
    RiCheckLine,
    RiHourglassLine,
    RiErrorWarningLine,
    RiCloseLine,
    RiCloseCircleLine,
    RiMessage2Line,
    RiSearchEyeLine,
    RiHistoryLine,
    RiAddCircleLine,
    RiDeleteBin2Line,
    RiMapPin2Line,
    RiArrowRightSLine,
    RiArrowLeftSLine,
    RiDownloadLine,
    RiUploadLine,
    RiFileListLine,
    RiSecurePaymentLine,
    RiFileTextLine,
    RiArrowRightLine as GoIcon,
    RiTeamLine,
    RiUserSettingsLine,
    RiGraduationCapLine,
    RiFilePaper2Line,
    RiHand,
    RiUserLine,
    RiSurveyLine,
    RiRefreshLine,
    RiInformationLine,
    RiTaskLine,
    RiTimelineView,
    RiStickyNoteLine,
    RiAlertLine,
    RiTimeLine,
    RiCheckboxCircleLine,
    RiCheckboxBlankCircleLine,
} from '@remixicon/vue';

// #region Component Interface

export type Icons =
    | 'phone'
    | 'success'
    | 'pending'
    | 'warning'
    | 'primary'
    | 'danger'
    | 'email'
    | 'link'
    | 'edit'
    | 'event'
    | 'lock'
    | 'close'
    | 'messages'
    | 'inspect'
    | 'history'
    | 'cancelled'
    | 'documents'
    | 'document'
    | 'trash'
    | 'add'
    | 'address'
    | 'right'
    | 'left'
    | 'download'
    | 'upload'
    | 'payments'
    | 'go'
    | 'school'
    | 'agency'
    | 'staff'
    | 'student'
    | 'application'
    | 'self'
    | 'user'
    | 'form'
    | 'refresh'
    | 'timeline'
    | 'task'
    | 'note'
    | 'alert'
    | 'info'
    | 'clock'
    | 'check'
    | 'check-circle'
    | 'circle';

const props = withDefaults(
    defineProps<{
        icon: Icons;
        class?: any;
    }>(),
    {
        class: 'icon-sm',
    },
);

// #endregion

const icons: Record<Icons, Component | FunctionalComponent> = {
    phone: RiPhoneLine,
    email: RiMailLine,
    success: RiCheckLine,
    cancelled: RiCloseCircleLine,
    link: RiLink,
    edit: RiPencilLine,
    event: RiCalendar2Line,
    lock: RiLockLine,
    pending: RiHourglassLine,
    warning: RiErrorWarningLine,
    danger: RiErrorWarningLine,
    primary: RiInformationLine,
    close: RiCloseLine,
    messages: RiMessage2Line,
    inspect: RiSearchEyeLine,
    history: RiHistoryLine,
    add: RiAddCircleLine,
    trash: RiDeleteBin2Line,
    address: RiMapPin2Line,
    right: RiArrowRightSLine,
    left: RiArrowLeftSLine,
    download: RiDownloadLine,
    upload: RiUploadLine,
    documents: RiFileListLine,
    document: RiFileTextLine,
    payments: RiSecurePaymentLine,
    go: GoIcon,
    school: RiSchoolLine,
    agency: RiTeamLine,
    staff: RiUserSettingsLine,
    student: RiGraduationCapLine,
    application: RiFilePaper2Line,
    self: RiHand,
    user: RiUserLine,
    form: RiSurveyLine,
    refresh: RiRefreshLine,
    timeline: RiTimelineView,
    task: RiTaskLine,
    note: RiStickyNoteLine,
    alert: RiAlertLine,
    info: RiInformationLine,
    clock: RiTimeLine,
    check: RiCheckLine,
    'check-circle': RiCheckboxCircleLine,
    circle: RiCheckboxBlankCircleLine,
};
</script>

<template>
    <component :is="icons[icon]" :class="props.class" />
</template>
